import {useDebugValue} from 'react';

import classNames from 'classnames';

import {useSearchFormContext} from '../../../hooks';

const componentClassNamespace = 'search-form';
const componentClassName = `${componentClassNamespace}__fields`;

function useComponent() {
    const {
        form: {
            options: {
                showDestinationInput,
                showDatesInput,
                showGuestsInput,
                showSubmitButton
            }
        }
    } = useSearchFormContext();

    const className = classNames(componentClassName);

    const result = {
        className,
        showDestinationInput,
        showDatesInput,
        showGuestsInput,
        showSubmitButton
    };

    useDebugValue(result);

    return result;
}

export {useComponent};
